import { useQuery } from '@tanstack/react-query';
import { IUserOwnTractor, getUsersOwnTractors } from '../../../../api/user/queries/getUsersOwnTractors';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export interface IUseGetUsersOwnTractorsParams {
  searchParam?: {
    machineApprovalStatus: string;
  };
}

export const useGetUsersOwnTractors = ({ searchParam }: IUseGetUsersOwnTractorsParams) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IUserOwnTractor[]>(
    ['user_own_tractor', `machineApprovalStatus=${searchParam?.machineApprovalStatus}`],
    () => getUsersOwnTractors({ searchParam }),
    { enabled: isUserLoggedIn },
  );
};
